import { RoleBasedGuard } from '@classroom-ai/ui/auth/guard';
import { useAuthContext } from '@classroom-ai/ui/auth/hooks';
import { SplashScreen } from '@classroom-ai/ui/components/loading-screen';

// ----------------------------------------------------------------------

type Props = {
  children: React.ReactNode;
};

/**
 * Gates the dashboard to SCHOOL_STAFF (and ED360_STAFF) role claims. Renders inside
 * AuthGuard, so the user is already authenticated by the time this runs.
 */
export function TeacherGuard({ children }: Props) {
  const { user, loading } = useAuthContext();

  if (loading) {
    return <SplashScreen />;
  }

  return (
    <RoleBasedGuard currentRole={user?.role ?? ''} allowedRoles={['SCHOOL_STAFF', 'ED360_STAFF', 'DISTRICT_ADMIN']} hasContent>
      {children}
    </RoleBasedGuard>
  );
}
